import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useDispatch } from "react-redux";
import { processRavenPayment } from "../../../../store/modules/payments";
import {
  ArrowCircle,
  CancelIcon,
  CardPaymentIcon,
} from "../../../../assets/svgIcons";
// import RavenIcon from "../../../../assets/svgIcons/RavenIcon";
import usePaymentCardModal from "./usePaymentCardModal";

const PaymentCardModal = ({
  closeModal,
  amount = "",
  closePaymentSession,
  selectBank,
}) => {
  const { payViaExternal } = usePaymentCardModal({
    selectBank,
    closePaymentSession,
    closeModal,
  });
  const dispatch = useDispatch();
  return (
    <>
      <div>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ gap: "100px" }}
        >
          <h6 className="dark--text mb-3">
            Select a Terminal To Collect Card Payment
          </h6>
          <div onClick={() => closeModal()}>
            <CancelIcon />
          </div>
        </div>
        <hr style={{ marginLeft: "-15px", marginRight: "-15px" }} />
        <div
          className={`${globalStyles.cardWithBorder} mb-3`}
          style={{ cursor: "pointer" }}
          onClick={() => {
            dispatch(
              processRavenPayment({
                amount: amount,
                allowFeedBack: false,
              }),
            );
            closeModal();
          }}
        >
          <div
            className={`${globalStyles.rowSpaceBetween} align-items-center p-0`}
            style={{ gap: "10px" }}
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ gap: "10px" }}
            >
              {/* <RavenIcon /> */}
              <div>
                <p className="dark--text small-text-size">
                  <strong>Use Raven</strong>
                </p>
                <p className="dark--gray smallest-text-size">
                  Process the payment through Raven. It is connected to your
                  checkout and automatically reconciles payments with your
                  sales.
                </p>
              </div>
            </div>
            <ArrowCircle stroke="#15112D" width="20" height="20" />
          </div>
        </div>
        <div
          className={`${globalStyles.cardWithBorder} mb-3`}
          style={{ cursor: "pointer" }}
          onClick={payViaExternal}
        >
          <div
            className={`${globalStyles.rowSpaceBetween} align-items-center p-0`}
            style={{ gap: "10px" }}
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ gap: "10px" }}
            >
              <CardPaymentIcon width="40" height="41" />
              <div>
                {" "}
                <p className="dark--text small-text-size">
                  <strong>Card payment already collected</strong>
                </p>
                <p className="dark--gray smallest-text-size">
                  If you have already collected the payment before reaching this
                  point choose this option.
                </p>
              </div>
            </div>
            <ArrowCircle stroke="#15112D" width="20" height="20" />
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentCardModal;
